import { ForgotPasswordOtp } from "kh-design-system/components";
import React, { useEffect, useState } from "react";
import { useEvent } from "../../contexts/EventContext";
import { Auth } from "aws-amplify";
import { authentication, authenticationModuleNames } from "../../utils/constants";

const ForgotPasswordOtpWrapper = ({
	setSwitchComponent,
	emailValue,
	isError,
	setIsError,
	toasterMessage,
	setToasterMessage,
	notificationPopup,
	setNotificationPopup,
	...props
}: {
	setSwitchComponent: React.Dispatch<React.SetStateAction<string>>;
	emailValue: string;
	isError: boolean;
	setIsError: React.Dispatch<React.SetStateAction<boolean>>;
	toasterMessage: string;
	setToasterMessage: React.Dispatch<React.SetStateAction<string>>;
	notificationPopup: boolean;
	setNotificationPopup: React.Dispatch<React.SetStateAction<boolean>>;
	[key: string]: any;
}) => {
	const { eventDetails } = useEvent();
	const primaryColor = eventDetails?.gallery_brand_color;
	const fontFamily = eventDetails?.gallery_font;

	const [timer, setTimer] = useState(30);
	const [loading, setLoading] = useState(false);
	const [otp, setOtp] = useState(Array(6).fill(""));
	const [showTimer, setShowTimer] = useState(true);

	const isOtpValid = otp.every(num => num !== "");

	const [verificationError, setVerificationError] = useState("");

	const handleResendOtp = async (email: string) => {
		setOtp(Array(6).fill(""));
		setTimer(30);
		setShowTimer(true);
		try {
			if (email) {
				const response = await Auth.forgotPassword(email); // Call reset password function
				if (response) {
					setToasterMessage(authentication.success.OTP_RESENT_SUCCESS);
					setNotificationPopup(true);
				}
			} else {
				setVerificationError(authentication.error.INVALID_EMAIL);
			}
		} catch (error) {
			console.error("Error during OTP resend:", error);
			setIsError(true);
			setToasterMessage(authentication.error.FAILED_RESENT_OTP);
			setNotificationPopup(true);
		}
		setVerificationError("");
	};

	const handleResetPassword = async (email: string, newPassword: string) => {
		if (!newPassword) {
			setIsError(true);
			setToasterMessage(authentication.error.NEW_PASSWORD_REQUIRED);
			setNotificationPopup(true);
			return;
		}
		setLoading(true);

		try {
			const response = await Auth.forgotPasswordSubmit(email, otp.join(""), newPassword);
			if (response) {
				setLoading(false);
				setToasterMessage(authentication.success.PASSWORD_CHANGED_SUCCESS);
				setNotificationPopup(true);
				setTimeout(() => {
					setSwitchComponent(authenticationModuleNames.SIGN_IN);
				}, 700);
			}
		} catch (error) {
			console.error("Error resetting password:", error);
			setLoading(false);
			setIsError(true);
			setToasterMessage(authentication.error.ERROR_OCCURRED);
			setNotificationPopup(true);
		}
	};

	useEffect(() => {
		if (timer > 0) {
			const interval = setInterval(() => {
				setTimer(prevTimer => prevTimer - 1);
			}, 1000);

			return () => clearInterval(interval); // Cleanup interval on unmount
		} else {
			setShowTimer(false); // Hide the timer when it reaches 0
		}
	}, [timer]);

	return (
		<>
			<ForgotPasswordOtp
				handleResendOtp={handleResendOtp}
				handleResetPassword={handleResetPassword}
				onBackClick={() => {
					setSwitchComponent(authenticationModuleNames.FORGOT_PASSWORD);
				}}
				emailValue={emailValue}
				otp={otp}
				setOtp={setOtp}
				verificationError={verificationError}
				timer={timer}
				showTimer={showTimer}
				isOtpValid={isOtpValid}
				loading={loading}
				primaryColor={primaryColor}
				fontFamily={fontFamily}
			/>
		</>
	);
};

export default ForgotPasswordOtpWrapper;
